import { TOGGLE_MODE } from "./types";

export const toggleMode = () => {
  return {
    type: TOGGLE_MODE
  };
};



// WEBPACK FOOTER //
// ./src/actions/mode_actions.js